<div class="page-container" >
    <ng-content></ng-content>
</div>
  
  